import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';

import { DayEntryModel, UserModel } from '../../models/models';
import { ConfigurationProvider, DayEntryProvider } from '../../providers/providers';

@Component({
  selector: 'page-dashboard-notes',
  templateUrl: 'dashboard-notes.html',
})
export class DashboardNotesPage {
  dayEntry: DayEntryModel;
  user: UserModel;

  constructor(
    private config: ConfigurationProvider,
    private dayEntryProvider: DayEntryProvider,
    private params: NavParams,
    private viewCtrl: ViewController) {
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  dismissView(item = null) {
    // dismiss the form
    this.viewCtrl.dismiss({
      saved: true,
      date: item ? item.Date : null,
      notes: item ? item.notes : null
    });
  }

  doSave() {
    this.config.showLoading('Saving...');

    // save day entry food items
    this.dayEntryProvider.Save(this.user, this.dayEntry, false).then((res: DayEntryModel) => {

      // reset and dismiss
      this.config.dismissLoading();
      this.dismissView(res);
    });
  }

  ionViewWillLoad() {
    this.dayEntry = this.params.get('dayEntry');
    this.user = this.params.get('user');
  }

}



// WEBPACK FOOTER //
// ./src/pages/dashboard/dashboard-notes.ts